export default function ActivityLevelValidationIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="4 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 11H8V12H17V11Z" fill="currentColor" />
      <path d="M8 13H17V14H8V13Z" fill="currentColor" />
      <path d="M17 15H8V16H17V15Z" fill="currentColor" />
      <path d="M17 17H8V18H17V17Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 8.34235L14.7541 4H6V21H19V8.34235ZM17.2667 8L15 5.68182V8H17.2667ZM7 5V20H18V9H14V5H7Z"
        fill="currentColor"
      />
    </svg>
  )
}
